import axios from "axios";
import i18next from 'i18next';

import {store} from "../configureStore";
import {shopsSetSimpleChat, updateCurrentShopAdministrator, updateNameShopAdministratorFail} from "../actions/Shops";
import {Toast} from '@capacitor/toast';



export function setSimpleChat(changeTo) {
     return function (dispatch) {
         const instance = axios.create({
             baseURL: process.env.REACT_APP_API_URL,
             timeout: 30000,
             headers: {
                 Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                 'Content-Type': 'application/json',
             },
         });

         return instance.patch(`shop/shops/${store.getState().Shops.activeShop.id}/`,{'simple_chat':changeTo}).then(({data}) => {
             dispatch(shopsSetSimpleChat(changeTo))
             return data;
         },err=>{
             return err;
         })
     }
}

export function updateAvatar(avatar_url, callbackSuccess, callback) {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,

            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                'Content-Type': 'application/json',
            },
        });

        return instance.post(`operators/operators/undefined/update_avatar_url/`, {avatar_url}).then(({data}) => {
            if (data.status === 'ok') {
                const newCurrentShopAdministrator = store.getState().Shops.currentShopAdministrator;
                newCurrentShopAdministrator.profile.avatar_url = avatar_url;

                dispatch(updateCurrentShopAdministrator(newCurrentShopAdministrator));

                callbackSuccess && callbackSuccess();
                callback && callback();
                Toast.show({text: 'Ok'});
            } else {
                callback && callback();
                Toast.show({text: i18next.t('errors.common.request_sent_short', 'Error sending request!')});
            }
        }, err => {
            callback && callback();
            Toast.show({text: i18next.t('errors.common.request_sent_short', 'Error sending request!')});
        })
    }
}

export function updateNameShopAdministrator(username, callback) {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,

            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                'Content-Type': 'application/json',
            },
        });

        instance.post('/operators/operators/undefined/update_name/', {username}).then(
            (response) => {
                if (response.data.status === 'ok') {
                    const newCurrentShopAdministrator = store.getState().Shops.currentShopAdministrator;
                    newCurrentShopAdministrator.profile.user.username = username;

                    dispatch(updateCurrentShopAdministrator(newCurrentShopAdministrator));

                    callback && callback();
                    Toast.show({text: 'Ok'});
                } else {
                    dispatch(updateNameShopAdministratorFail(response.data));
                    callback && callback();
                }
            },
            error => {
                callback && callback();
                Toast.show({text: i18next.t('errors.common.request_sent_short', 'Error sending request!')});
            },
        );
    }
}